export default "__VITE_ASSET__6tM5JtM$__"